import PropTypes from 'prop-types'
import { Row, Col, Alert, Button, Card, CardBody, Modal,
  ModalHeader,
  ModalBody,
  ModalFooter, Container } from "reactstrap"
import React, { useEffect, useState } from "react"
// Redux
import { connect } from "react-redux"
import { withRouter, Link, useLocation } from "react-router-dom"


import { Field, Form } from '@availity/form'
import { SelectField } from '@availity/select'
import '@availity/yup'
import * as yup from 'yup'
// action
import { registerUser, getPassword, createNewUser } from "../../store/auth/register/actions"

// import images
import logo from "../../assets/images/logo.svg"
import profile from "assets/images/profile-img.png"
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe('pk_live_32lR95oxzgmholKLYJVQ4wRh');

const ForgetPasswordPage = props => {
  const location = useLocation();
  const { onRegisterUser, onGetPassword, onCreateNewUser, registerPassword, userInfo, stripeSession } = props
  const [email, setEmail] = useState()
  const [stripe, setStripe] = useState()
    const [name, setName] = useState()
  const [sessionId, setSessionId] = useState()
  const [step, setStep] = useState("register")
  const [password, setPassword] = useState("")
  const [term, setTerm] = useState("")
  const [openAgreement, setOpenAgreement] = useState(false);

  const toggleAgreementModal = () => setOpenAgreement(!openAgreement);

    useEffect(() => {
        // Create the script tag
        const script = document.createElement('script');
        script.src = 'https://cdn.promotekit.com/promotekit.js';
        script.async = true;
        script.setAttribute('data-promotekit', 'fd700e3d-3706-4014-9122-fb22ab8437d6');

        // Append the script to the document body or head
        document.body.appendChild(script);

        // Clean up the script when the component unmounts
        return () => {
            document.body.removeChild(script);
        };
    }, []);

  useEffect(() => {
    console.log(location.pathname);

      if (location.pathname.indexOf("success")!=-1) {
          setStep("complete")
          const queryParams = new URLSearchParams(location.search);
          const email = queryParams.get('email');
          setEmail(email)
          const customer = queryParams.get("customer_id")
          const password = queryParams.get("password");
          const name = queryParams.get("name");
          var user = {
              username: email,
              name: name,
              email: email,
              customer_id: customer,
              password: password,
              role: "Subscriber"
          }
          onCreateNewUser(user)
      } else if (location.pathname.indexOf("cancel")!=-1) {
          setStep("cancel")
      } else {
          // Initialize Stripe on component mount
          const initializeStripe = async () => {
              const stripeInstance = await stripePromise;
              setStripe(stripeInstance);
          };

          initializeStripe();
      }
  }, []);

  useEffect(() => {
      const redirectCheckout = async () => {
      if (stripeSession) {
	 console.log(stripeSession);
	 const error = await stripe.redirectToCheckout({
             sessionId: stripeSession,
         });

         if (error) {
            console.error(error);
         }
      }
      };

      redirectCheckout();
  }, [stripeSession]);

  const handleRegister = (values, event) => {
      console.log(values)
      const affiliateId = window.promotekit_referral
      var user = {
          "email": values.email,
          "password": values.password,
          "name": values.name,
          "term": values.term,
          "affiliate_id": affiliateId,
      }
      onRegisterUser(user)

  }


  return (
    <React.Fragment>
     <div className="account-pages my-5 pt-sm-5">
        <Container>
	  {step=='register' && <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div style={{backgroundColor:"#738276"}}>
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 style={{textColor:"#384E3E"}}>Sign-up for a SAGE Subscription</h5>
                        <h6 style={{textColor:"#384E3E"}}>Enter in your email and password to create an account.</h6>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
	          <Form
                      className="form-horizontal"
                      onSubmit={handleRegister}
                      initialValues={{
                          name: '',
                          email: '',
                          password: '',
		          term: ''
                      }}
                      validationSchema={yup.object().shape({
                          name: yup
                              .string()
                              .isRequired(true, 'Name is required'),
                         email: yup
                            .string()
                            .isRequired(true, 'Email is required'),
                         password: yup
                             .string()
                             .isRequired(true, 'Password is required')
                             .min(8, 'Password must be at least 8 characters')
                             .matches(/[0-9]/, 'Password must contain at least 1 number')
                             .matches(/[A-Z]/, 'Password must contain at least 1 uppercase letter')
                             .matches(/[a-z]/, 'Password must contain at least 1 lowercase letter'),
			                   term: yup
                            .string()
                            .isRequired(true, 'Please choose whether you want to pay monthly($7/month) or yearly ($75)'),
                         agreement: yup
                            .bool()
                            .oneOf([true], 'You must agree to the terms and conditions to continue')
                      })}
                      validateOnChange={false}
                      validateOnBlur={true}
                    >
                  <div className="form-group">
                      <Field
                          name="name"
                          label="Name"
                          type="text"
                      />
                  </div>
                      <div className="form-group">
                        <Field
                          name="email"
                          label="Email"
                          type="text"
                        />
                      </div>

                      <div className="form-group">
                        <Field
                          name="password"
                          label="Password"
                          type="password"
                        />
                      </div>

		      <div className="form-group">
		         <SelectField
                             label="Subscription Payment"
                              name="term"
                              isMulti={false}
                              options={[
                                  { label: 'Monthly ($7/month)', value: "Monthly" },
                                  { label: 'Yearly ($75/year)', value: "Yearly" },
                              ]}
                          />
                      </div>

                      <div>
<Field
        type="checkbox"
        name="agreement"
       label={
            <>
              I have read and agree to the{' '}
              <span
                style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
                onClick={toggleAgreementModal}
              >
                SAGE App User Agreement
              </span>.
            </>
          }
          />
        
                      </div>


                      <div className="mt-3">
                        <button
                        className="btn btn-success btn-block waves-effect waves-light"
                          type="submit"
                        >
                          Create
                        </button>
                      </div>
              </Form>
                </CardBody>
                 </Card>
                <div>
                <p>
                  © {new Date().getFullYear()} Permaculture Gardens, LLC.
                </p>
              </div>
            </Col>
          </Row>
	  }
{step=='complete' && <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div style={{backgroundColor:"#738276"}}>
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 style={{textColor:"#384E3E"}}>SAGE Subscription Complete</h5>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div>
                     <Row>
                         <Col><p style={{fontSize: "12pt", marginBottom:"10px"}}>
                             Congratulations! {'\uD83C\uDF89'} <br/>
                             You’ve successfully subscribed to SAGE!<br/>
                             To get started, <a href="/home">log in to SAGE now</a> and begin designing your dream garden.<br/>
                             We’ve also emailed you important account details and will keep you updated about upcoming events, webinars, and tutorials to help you make the most of SAGE.
                             Let’s grow abundantly together! {'\uD83C\uDF31'} </p></Col>
                      </Row>
                  </div>
                </CardBody>
                 </Card>
                <div>
                <p>
                  © {new Date().getFullYear()} Permaculture Gardens, LLC.
                </p>
              </div>
            </Col>
          </Row>
          }


{step=='cancel' && <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div style={{backgroundColor:"#738276"}}>
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 style={{textColor:"#384E3E"}}>SAGE Subscription Not completed.</h5>
                      </div>
		   </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div>
                     <Row>
		         <Col>
		 <h5 style={{textColor:"#FF0000"}}>You have not finished setting up your subscription and payment options for your SAGE account.  Please go back to the <a href="/register">Registration</a> page to try to create your account again.</h5>

		</Col>
                      </Row>
                  </div>
                </CardBody>
                 </Card>
                <div>
                <p>
                  © {new Date().getFullYear()} Permaculture Gardens, LLC.
                </p>
              </div>
            </Col>
          </Row>
          }



        </Container>
      </div>

<Modal isOpen={openAgreement} toggle={toggleAgreementModal}>
        <ModalHeader toggle={toggleAgreementModal}>SAGE App User Agreement</ModalHeader>
        <ModalBody>
          <p>
            This User Agreement ("Agreement") is a legal contract between you ("User" or "you") and Permaculture Gardens, LLC ("we," "us," or "our") governing your purchase and use of the SAGE App ("App").
            By purchasing, downloading, or using the App, you agree to be bound by the terms and conditions of this Agreement.
          </p>
          <h5>1. License</h5>
          <p>
            Subject to your compliance with the terms of this Agreement, we grant you a non-exclusive, non-transferable, revocable license to access and use the App for personal, non-commercial purposes. You may not sublicense, distribute, or sell access to the App.
          </p>
          <h5>2. User Responsibilities</h5>
          <p>
            You agree not to reverse-engineer, modify, or attempt to gain unauthorized access to any part of the App. You must be at least 18 years old to use the App or have obtained parental or guardian consent to use it if you are a minor.
            You are responsible for maintaining the confidentiality of your login information and for all activities that occur under your account.
          </p>
          <h5>3. Payment Terms</h5>
          <p>
            All payments for the App are non-refundable unless required by law. You are responsible for any additional charges imposed by third-party payment processors or your financial institution.
          </p>
          <h5>4. Intellectual Property</h5>
          <p>
            All content, features, and functionality of the App, including but not limited to text, graphics, logos, and software, are the exclusive property of Permaculture Gardens, LLC and are protected by intellectual property laws.
            You are prohibited from copying, distributing, or creating derivative works from the App without our express permission.
          </p>
          <h5>5. Privacy</h5>
          <p>
            We respect your privacy. Our Privacy Policy outlines how we collect, use, and protect your personal data when using the App. By using the App, you agree to the terms outlined in our Privacy Policy.
          </p>
          <h5>6. Updates and Modifications</h5>
          <p>
            We reserve the right to update or modify the App at any time to enhance performance or security. You may be required to install the latest updates in order to continue using the App.
          </p>
          <h5>7. Termination</h5>
          <p>
            We may terminate or suspend your access to the App at any time if we believe you have violated any terms of this Agreement. Upon termination, you must immediately cease using the App.
          </p>
          <h5>8. Limitation of Liability</h5>
          <p>
            To the maximum extent permitted by law, Permaculture Gardens, LLC shall not be liable for any indirect, incidental, or consequential damages arising from your use or inability to use the App, including but not limited to loss of data or profits.
          </p>
          <h5>9. Disclaimer of Warranties</h5>
          <p>
            The App is provided "as-is" without any warranties of any kind. We do not guarantee that the App will be error-free, uninterrupted, or meet your expectations. We disclaim all warranties, express or implied, to the maximum extent permitted by law.
          </p>
          <h5>10. Governing Law</h5>
          <p>
            This Agreement shall be governed by and construed in accordance with the laws of the Commonwealth of Virginia, without regard to its conflict of law principles. Any disputes arising from this Agreement will be resolved in the state or federal courts located in Virginia.
          </p>
          <h5>11. Amendments</h5>
          <p>
            We reserve the right to amend this Agreement at any time. Changes will be effective upon posting the revised Agreement on our website or within the App. Continued use of the App after such changes indicates your acceptance of the revised Agreement.
          </p>
          <h5>12. Contact Information</h5>
          <p>
            If you have any questions or concerns regarding this Agreement, please contact us at:<br />
            <strong>Permaculture Gardens, LLC</strong><br />
            41558 Stumptown Rd, Leesburg, VA 20176<br />
            permaculturegardens@gmail.com
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleAgreementModal}>Close</Button>
        </ModalFooter>
      </Modal>


    </React.Fragment>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
     stripeSession: state.Account.sessionId,
     userInfo: state.Account.userInfo,
     registerPassword: state.Account.password
  }
}


const mapDispatchToProps = dispatch => ({
   onRegisterUser: user => dispatch(registerUser(user)),
   onCreateNewUser: user => dispatch(createNewUser(user)),
   onGetPassword: password => dispatch(getPassword(password)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ForgetPasswordPage))

